import { render, staticRenderFns } from "./SensorSetting.vue?vue&type=template&id=068e9b67&scoped=true"
import script from "./SensorSetting.vue?vue&type=script&lang=js"
export * from "./SensorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068e9b67",
  null
  
)

export default component.exports